import { api } from "./api";

const BASE = "/api/v1/me/alert-settings";

/**
 * Malfunctioning-device email alerts.
 *
 * PERSONAL, unlike the John Deere sync settings next door: the backend keys
 * these on the real logged-in person, not the account being viewed. A team
 * member viewing an owner's account still reads and writes their OWN setting,
 * and an owner switching alerts on does not enrol their team — everyone opts in
 * for themselves.
 */
export interface DeviceAlertSettings {
  malfunctionEmails: boolean;
  /** Alerts cannot be enabled for an address we cannot reach. */
  emailVerified: boolean;
  /** The address alerts would go to — shown next to the toggle. */
  email: string;
}

export const getDeviceAlertSettings = (): Promise<DeviceAlertSettings> =>
  api.get<DeviceAlertSettings>(BASE);

export const putDeviceAlertSettings = (
  malfunctionEmails: boolean
): Promise<DeviceAlertSettings> => api.put<DeviceAlertSettings>(BASE, { malfunctionEmails });
